import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, ElementRef, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { FiletypeDropdownComponent } from 'src/app/components/file-type-selector/file-type-selector.component';
import { FileTypeInfo, SupportedFileTypes } from 'src/app/models/file-type.models';
import { TextControlService } from 'src/app/services/text-control.service';
import { environment } from 'src/environments/environment';
import { FormsModule, NgForm } from '@angular/forms';
import { SaveSnippetRequest } from 'src/app/models/snippet-requests.model';
import { SnippetService } from 'src/app/services/snippet-service';
import { DialogService } from 'src/app/services/dialog.service';
import { catchError, take } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SnippetBodyType, SnippetsViewModel } from 'src/app/models/snippets-view.model';
import { DocumentDataService } from 'src/app/services/document-data.service';
import { TextControlContext } from 'textcontrol-promises-develop';
import { CallbackType } from 'custom_modules/textcontrol-promises-develop/src/helper/CallbackType';
import { bind } from 'lodash';

declare const TXTextControl: any;

// const defaultSnippetText = 'This is a sample snippet body. You can edit this text to create your own snippet.';
const defaultSnippetText = '';
@Component({
  selector: 'tx-snippet-add-dialog',
  templateUrl: './snippet-add-dialog.component.html',
  styleUrls: ['./snippet-add-dialog.component.scss'],
})
export class SnippetAddDialogComponent {
  @ViewChild('snippetForm', { static: false }) snippetForm!: NgForm;
  public SnippetModel?: SnippetsViewModel;
  public editMode: 'Edit' | 'Add' | 'Copy' = 'Add';
  public selectionStartPosition = 0;
  public startParagraph = 0;
  public startParaPosition = 0;
  public selectionLength = 0;
  public endParagraph = 0;
  public endParaStartPosition = 0;
  public endParagraphLength = 0;
  documentName: string = '';
  savingAction: boolean = false;
  snippetTitle: any = '';
  snippetBody: string = '';
  websocketUrl = environment.endpoints.websocketUrl;
  snippetNote: any;
  sharedSnippet: boolean = false;
  generalSnippet: boolean = false;
  constructor(
    public activeModal: NgbActiveModal,
    public textControlService: TextControlService,
    public snippetService: SnippetService,
    public dialogService: DialogService,
    public authenticationService: AuthenticationService,
    public documentDataService: DocumentDataService,
    public toastService: ToastService,
    private changeDetector: ChangeDetectorRef
  ) {}
  init: EditorComponent['init'] = {
    license_key: 'gpl',
    base_url: '/tinymce', // Root for resources
    promotion: false,
    suffix: '.min',
    menubar: false,
    statusbar: false,
    outputFormat: 'html',
    // editable_root: false,
    noneditable_class: 'mceNonEditable',
    editable_class: 'mceEditable',
    content_css: '/assets/custom-styles.css',
    formats: {},
    resize: true,
    height: '100%',
    //paste_as_text: true,
    smart_paste: false,
    paste_data_images: false,
    paste_preprocess: (editor, args) => {
      args.content = this.processHtmlContent(args.content, false, false);
    },
    toolbar: 'bold italic underline',
    setup: (editor: any) => {
      // editor.on('focus', function (e: any) {
      //   var searchText = defaultSnippetText;
      //   var found = false;
      //   var treeWalker = editor.getDoc().createTreeWalker(editor.getBody(), NodeFilter.SHOW_TEXT, null, false);
      //   var node;
      //   while ((node = treeWalker.nextNode())) {
      //     var index = node.nodeValue.indexOf(searchText);
      //     if (index !== -1) {
      //       found = true;
      //       var rng = editor.selection.getRng(true);
      //       rng.setStart(node, index);
      //       rng.setEnd(node, index + searchText.length);
      //       editor.selection.setRng(rng);
      //       break;
      //     }
      //   }
      //   if (!found) {
      //     // do nothing
      //   }
      //});
    },
  };

  async ngOnInit() {
    let htmlContent = '';
    if (this.SnippetModel && this.SnippetModel.snippetGuid == '') {
      this.editMode = 'Copy';
      this.snippetTitle = this.SnippetModel.snippetTitle;
      htmlContent = this.SnippetModel.snippetBody;
      this.snippetNote = this.SnippetModel.snippetNote;
      this.snippetBody = this.buildSnippetBody(htmlContent);
      this.generalSnippet = this.SnippetModel.praSysId === 0;
    } else if (this.SnippetModel) {
      this.editMode = 'Edit';
      this.snippetTitle = this.SnippetModel.snippetTitle;
      htmlContent = this.SnippetModel.snippetBody;
      this.snippetNote = this.SnippetModel.snippetNote;
      this.sharedSnippet = this.SnippetModel.sharedSnippet == 1;
      this.snippetBody = this.buildSnippetBody(htmlContent);
      this.generalSnippet = this.SnippetModel.praSysId === 0;
    } else {
      await this.getTXtextSelectionValues();
      this.editMode = 'Add';
      this.generalSnippet = this.documentDataService.getPraSysId() === 0;
      if (!this.selectionLength) {
        htmlContent = defaultSnippetText;
        this.snippetBody = this.buildSnippetBody(htmlContent);
      } else {
        TXTextControl.selection.save(
          TXTextControl.StreamType.HTMLFormat,
          (data: any) => {
            //console.log(
            //  'HTML content',
            //  data.data,
            //  `${this.selectionStartPosition == this.startParaPosition} == ${this.selectionStartPosition} == ${
            //    this.startParaPosition
            //  }`,
            //  `${
            //    this.endParaStartPosition + this.endParaStartPosition + this.endParagraphLength ==
            //    this.selectionStartPosition + this.selectionLength
            //  } == ${this.endParaStartPosition} + ${this.endParaStartPosition} + ${this.endParagraphLength} == ${
            //    this.selectionStartPosition
            //  } + ${this.selectionLength}`
            //);
            htmlContent = this.processHtmlContent(
              data.data,
              this.selectionStartPosition == this.startParaPosition,
              this.endParaStartPosition + this.endParagraphLength == this.selectionStartPosition + this.selectionLength
            );
            this.snippetBody = this.buildSnippetBody(htmlContent);
            this.changeDetector.detectChanges();
          },
          { cssSaveMode: TXTextControl.SaveSettings.CssSaveMode.Inline }
        );
      }
    }

    this.changeDetector.detectChanges();
  }

  private async getTXtextSelectionValues() {
    let txContext = new TextControlContext();
    this.selectionStartPosition = await txContext.selection.getStart();
    this.selectionLength = await txContext.selection.getLength();

    this.startParagraph = await this.textControlService.getParagraphAtPositionPromise(this.selectionStartPosition);
    this.startParaPosition = await this.textControlService.getParagraphStartPositionPromise(this.startParagraph);
    this.endParagraph = await this.textControlService.getParagraphAtPositionPromise(
      this.selectionStartPosition + (this.selectionLength - 1) // -1 to remove the paragraph marker
    );
    this.endParaStartPosition = await this.textControlService.getParagraphStartPositionPromise(this.endParagraph);
    this.endParagraphLength = await this.textControlService.getParagraphLengthPromise(this.endParagraph);
  }

  async ngAfterViewInit() {
    //this.textControlService;
  }
  buildSnippetBody(htmlContent: string): string {
    return (
      // "<span class='readonly mceNonEditable'>Lorem, ipsum dolor sit</span><span class='mceEditable'>" +
      htmlContent
      // + "</span><span class='readonly mceNonEditable'> amet consectetur adipisicing elit.</span>"
    );
  }
  submitForm(form: NgForm) {
    if (form.invalid) {
      return;
    }
    const cleanedBody = this.processHtmlContent(
      form.value.snippetBody,
      this.SnippetModel?.snippetGuid == '' &&
        (this.editMode == 'Edit' || this.editMode == 'Copy' || this.selectionStartPosition == this.startParaPosition),
      this.editMode == 'Edit' ||
        this.editMode == 'Copy' ||
        this.endParaStartPosition + this.endParagraphLength == this.selectionStartPosition + this.selectionLength
    );
    let details = this.authenticationService.getUserDetails();
    const newPraSysId = this.generalSnippet ? 0 : this.documentDataService.getPraSysId() || 0;
    const newTemplateId = this.generalSnippet ? 0 : this.documentDataService.getTemplateId() || 0;
    let currentPraSysId = this.SnippetModel ? this.SnippetModel.praSysId || 0 : 0;
    let currentTemplateId = this.SnippetModel ? this.SnippetModel.templateSysId || 0 : 0;
    // Update the PraSysId and TemplateSysId only if it's a 0 to non-zero transition or vice-versa
    // We don't want the snippet to be changed to a different practice area
    const shouldUpdate = (currentPraSysId === 0) !== (newPraSysId === 0);

    const result: SaveSnippetRequest = {
      ...details,
      StaffId: details.StaffGuid,
      SnippetGuid: this.SnippetModel?.snippetGuid || '',
      SnippetTitle: form.value.snippetTitle,
      SnippetNote: form.value.snippetNote,
      SnippetBody: cleanedBody,
      SharedSnippet: this.sharedSnippet,
      PraSysId: shouldUpdate ? newPraSysId : currentPraSysId,
      TemplateId: shouldUpdate ? newTemplateId : currentTemplateId,
      SnippetBodyType: SnippetBodyType.HTML,
    };

    this.savingAction = true;
    this.snippetService
      .saveSnippet(result)
      .pipe(
        take(1),
        catchError((err: any) => {
          console.error('Error saving snippet', err);
          if (err.httpStatusCode == 409) {
            this.dialogService.info({
              title: `Trouble saving snippet`,
              message: `There was a problem saving you snippet. Please try again.`,
            });
          }
          throw err;
        })
      )
      .subscribe((res) => {
        this.toastService.show('Snippet saved successfully', { classname: 'bg-success', autohide: true });
        this.activeModal.close();
      });
  }

  processHtmlContent(htmlContent: string, startOfParagraph: boolean, endOfParagraph: boolean): string {
    // Create a DOM parser to parse the HTML content
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    Array.from(doc.getElementsByClassName('readonly')).forEach((el) => {
      el.remove();
    });
    // Move paragraph formatting to spans
    Array.from(doc.getElementsByTagName('p')).forEach((paragraph) => {
      const span = document.createElement('span');
      if (paragraph.hasAttribute('class')) {
        span.setAttribute('class', paragraph.getAttribute('class') || '');
      }
      if (paragraph.hasAttribute('style')) {
        span.setAttribute('style', paragraph.getAttribute('style') || '');
      }
      while (paragraph.firstChild) {
        span.appendChild(paragraph.firstChild);
      }
      paragraph.appendChild(span);
    });

    // Remove all styling except font-weight, font-style, and underline for spans
    const allElements = doc.body.querySelectorAll('*');
    allElements.forEach((el) => {
      if (el instanceof HTMLElement) {
        const allowedTags = ['P', 'SPAN', 'STRONG', 'EM', 'U', 'BR', 'B', 'I', 'U'];
        if (!allowedTags.includes(el.tagName)) {
          // Remove disallowed tags by replacing them with their inner content
          el.replaceWith(...Array.from(el.childNodes));
        } else {
          // Remove disallowed inline styles
          const computedStyle = window.getComputedStyle(el);

          const fontWeight = el.style.fontWeight || computedStyle.fontWeight;
          const fontStyle = el.style.fontStyle || computedStyle.fontStyle;
          const textDecoration = el.style.textDecoration || computedStyle.textDecorationLine;

          el.removeAttribute('style'); // Clear all styles

          // Reapply allowed styles if present
          if (fontWeight === 'bold' || el.tagName === 'B' || el.tagName === 'STRONG') el.style.fontWeight = fontWeight;
          if (fontStyle === 'italic' || el.tagName === 'I' || el.tagName === 'EM') el.style.fontStyle = fontStyle;
          if (textDecoration === 'underline' || el) el.style.textDecoration = textDecoration;
        }
      }
    });

    // Select all <p> elements
    let paragraphs = doc.body.querySelectorAll('p');
    if (
      (!startOfParagraph && paragraphs.length > 0) ||
      (startOfParagraph && endOfParagraph && doc.body.children.length === 1)
    ) {
      // Unwrap the first <p> element if it exists
      const firstP = paragraphs[0];
      firstP.replaceWith(...Array.from(firstP.childNodes));
    }

    //refresh paragraphs
    paragraphs = doc.body.querySelectorAll('p');
    paragraphs.forEach((element) => {
      element.replaceWith(doc.createElement('br'), ...Array.from(element.childNodes));
    });
    if (endOfParagraph) {
      const emptyP = doc.createElement('br');
      doc.body.appendChild(emptyP); // Append an empty paragraph at the end
    }
    const breaks = doc.body.querySelectorAll('br');
    if (doc.body.lastChild && doc.body.lastChild.nodeName === 'BR') {
      doc.body.removeChild(doc.body.lastChild);
    }
    return doc.body.innerHTML;
  }
}
